import fuzzysort from 'fuzzysort'

import { integrationName } from './helpers'

export const SEARCH_DATA_FIELD = 'searchData'

export const getIntegrationSearchData = (item, isRebrandEnabled = false) => {
  const fields = [integrationName(item, isRebrandEnabled)]

  if (item.tags) {
    fields.push(...item.tags)
  }

  if (item.admin) {
    fields.push('admin')
  }

  const text = fields.join(' ')
  return fuzzysort.prepare(text)
}

export const findMatchingIntegrations = (targets, text, searchKeys, isRebrandEnabled = false) => {
  if (text === null || text === undefined) {
    return []
  }

  const cleanTerm = text.trim()
  if (!cleanTerm) {
    return []
  }

  const searchTargets = searchKeys.includes(SEARCH_DATA_FIELD)
    ? targets.map((item) => ({
      ...item,
      [SEARCH_DATA_FIELD]: getIntegrationSearchData(item, isRebrandEnabled),
    }))
    : targets

  const matches = fuzzysort.go(cleanTerm, searchTargets, {
    keys: searchKeys,
    threshold: 0.65, // match scores below this on a [0,1] scale will be discarded
  })

  const results = matches.map((o) => o.obj)
  return results
}
